export default () => {
    window.jQuery('button[data-disable-on-submit]').each((index, button) => {
        const form = document.querySelector(button.getAttribute("data-disable-on-submit-form"));
        if (!form) { return; }

        $(form).on('submit', (ev) => { button.disabled = true; });
    });
}
